import tp1 from "../../Images/Tour Packages/tp1.webp";
import TravelEnquiryPage from "./TravelEnquiryPage";

const TourPackagesPage = () => (
  <TravelEnquiryPage
    eyebrow="Make the journey yours"
    title="Plan your next tour"
    description="Have a destination in mind or need a little inspiration? Send us your preferred dates, group size, and the kind of trip you are looking for. Our team will help you explore tour options and plan the next steps."
    image={tp1}
    imageAlt="The Taj Mahal, a popular travel destination in India"
    highlights={[
      "Enquire about destinations and trip options",
      "Plan around your preferred dates and group size",
      "Get in touch to discuss your travel requirements",
    ]}
    enquiryMessage="Enquire about tour packages"
  />
);

export default TourPackagesPage;
